"use strict";
//@ts-nocheck
/*global $*/
/*global window*/
/*global document*/
/*global console*/
/*global setTimeout*/
/*global jRespond*/
/*global TYPO3*/
(function () {
    'use strict';
    var exports = {
        initializeErrorMessageHandling: function () {
            $('.c4l-order-form').find('.mandatory-message').find('a').on('click', function (event) {
                event.preventDefault();
                var $anchor = $(this);
                var $targetElement = $($anchor.attr('href'));
                var targetOffset = $targetElement.offset().top;
                $('html,body').animate({
                    scrollTop: targetOffset
                }, 500, function () {
                    $targetElement.trigger('focus');
                    $targetElement.trigger('select');
                });
            });
        },
        attachVatNumberSelectionEvents: function () {
            if (typeof (TYPO3) !== 'undefined'
                && typeof (TYPO3.settings) !== 'undefined'
                && typeof (TYPO3.settings.Gs1) !== 'undefined'
                && typeof (TYPO3.settings.Gs1.countriesWithVat) !== 'undefined') {
                var countryField = $('#companyCountry'), vatNumberField = $('#companyTaxId'), vatNumberFieldWrap = vatNumberField.closest('.form-group'), toggleVatNumberField = function (toggle) {
                    if (!toggle) {
                        vatNumberField.val('');
                    }
                    vatNumberFieldWrap.toggle(toggle);
                }, checkVatNumberField = function () {
                    toggleVatNumberField($.inArray(countryField.val(), TYPO3.settings.Gs1.countriesWithVat) !== -1);
                };
                checkVatNumberField();
                countryField.on('change', function () {
                    checkVatNumberField();
                });
            }
        },
        /**
         * Disable the submit button in C4L order after submit (a.k.a. poor man's double click/double order prevention)
         */
        attachSubmitFormEvents: function () {
            $('form[name="order"]').submit(function () {
                $(this).find('button[type=submit]').prop('disabled', true);
            });
        }
    };
    exports.initializeErrorMessageHandling();
    exports.attachVatNumberSelectionEvents();
    exports.attachSubmitFormEvents();
})();
